import axiosInstance from "../../app/apiClient";
import { DataKitchenParam, KitchenAdminService } from "../model/kitchen.model";

const getKitchenData = (status: any, value: any, isDisable: boolean = false) =>
	axiosInstance.get(
		`api/v1/kitchens?kitchenName=${value}&status=${status}&isDisablePermission=${isDisable}`
	);
const getAllKitchenData = (status: any, value: any) =>
	axiosInstance.get(
		`api/v1/kitchens?kitchenName=${value}&status=${status}&isDisablePermission=TRUE`
	);
const addKitchen = (data: any) => axiosInstance.post(`api/v1/kitchens`, data);
const kitchenDefault = () =>
	axiosInstance.get("api/v1/customers/kitchenDefault");
const updateKitchen = (id: number, data: any) =>
	axiosInstance.put(`/api/v1/kitchens/${id}`, data);
const removeKitchen = (id: number) =>
	axiosInstance.delete(`api/v1/kitchens/${id}`);
const searchKichen = (kitchenName: string) =>
	axiosInstance.get(`api/v1/kitchens/searches?kitchenName=${kitchenName}`);
const getOneKitchen = (id: number) =>
	axiosInstance.get(`api/v1/kitchens/${id}`);

const kitchenAdmin: KitchenAdminService = {
	getKitchenData,
	getAllKitchenData,
	addKitchen,
	updateKitchen,
	removeKitchen,
	searchKichen,
	getOneKitchen,
	kitchenDefault,
};
export default kitchenAdmin;
